export default __webpack_public_path__ + "static/media/basketball-active.7554cc34.webp";